var render = function render(){
  var _vm$applications, _vm$applications$leng, _vm$applications$leng2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    staticClass: "fill-height",
    attrs: {
      "value": _vm.TABS.FINISH.value
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "justify-center": "",
      "fill-height": ""
    }
  }, [_c('div', {
    staticClass: "scroll-primary",
    staticStyle: {
      "flex": "1 1 auto",
      "overflow-y": "auto"
    }
  }, [_c('v-sheet', {
    staticClass: "pa-40 pa-lg-60"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h3', {
    staticClass: "tit mb-8 mb-lg-16"
  }, [_vm._v("송부 완료")]), _c('p', {
    staticClass: "page-text--lg grey-6--text"
  }, [_vm._v(" 총 " + _vm._s(((_vm$applications = _vm.applications) === null || _vm$applications === void 0 ? void 0 : (_vm$applications$leng = _vm$applications.length) === null || _vm$applications$leng === void 0 ? void 0 : (_vm$applications$leng2 = _vm$applications$leng.format) === null || _vm$applications$leng2 === void 0 ? void 0 : _vm$applications$leng2.call(_vm$applications$leng)) || 0) + "건의 계약서가 송부 되었습니다. "), _c('br'), _vm._v(" 근로자 현황에서 확인 가능합니다. ")])]), _c('div', {
    staticClass: "v-btn-group"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('exit');
      }
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("확인")])]), _c('texting-dialog', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "min-w-140px min-w-lg-160px",
          attrs: {
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('span', [_vm._v("문자발송")])])];
      }
    }])
  }, 'texting-dialog', _vm.textingProps, false))], 1)])], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }